import { render, staticRenderFns } from "./XwpImageLiveness.vue?vue&type=template&id=cede4fc8&"
import script from "./XwpImageLiveness.vue?vue&type=script&lang=js&"
export * from "./XwpImageLiveness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports